<template>
<div class="hl-wid ww4 welcome-page-container" v-if="!loggedIn">
<div class="welcome-page">
  <a class="register" href="" v-on:click.prevent="doLogin"></a>
</div>
</div>
</template>

<script>
export default {
  data: ()=>({
    cventLink: window.cventLink,
  }),
  computed: {
    loggedIn() {
      return appRoot.loggedIn;
    },
  },
  methods: {
    doLogin() {
      if (window.appHeadNav)
        window.appHeadNav.currentPane='register';
    },
  },
}
</script>
